import { render, staticRenderFns } from "./FieldAvatar.vue?vue&type=template&id=7f7b4af0&"
import script from "./FieldAvatar.vue?vue&type=script&lang=js&"
export * from "./FieldAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports